module.exports = __webpack_public_path__ + "img/news_3_1.2a248db7.jpg";